import { validateEnvVariable } from './helpers';

const API_BASE_URL = validateEnvVariable(import.meta.env.VITE_API_BASE_URL);

const apiEnvironment = {
  API_BASE_URL,
};

export default apiEnvironment;
